import { __awaiter } from "tslib";
import { DataCollectionEventNames } from './plugins/datacollection';
import { EventServiceErrorType } from './plugins/eventservice';
export class FacadeRegistry {
    static adaptJWeb(jWeb) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('FacadeRegistry::adaptJWeb');
            FacadeRegistry.facades.forEach((adaptFunction) => {
                adaptFunction(jWeb);
            });
            return jWeb;
        });
    }
    static createEventSubscriber(jWeb) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('FacadeRegistry::createEventSubscriber');
            if (jWeb.Plugins.EventService) {
                const createSubscriberOptions = {
                    allowEventingFallback: true
                };
                try {
                    const subscriber = yield jWeb.Plugins.EventService.createSubscriber(createSubscriberOptions);
                    if (FacadeRegistry.isSubscriber(subscriber)) {
                        return subscriber;
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
            return null;
        });
    }
    static isSubscriber(result) {
        return result.subscribe !== undefined;
    }
    static isLegacyDataCollectionPlugin(plugin) {
        return plugin.refreshCollectionProfile !== undefined
            && plugin.sendUiEvent !== undefined;
    }
    static addEventUnsubscriber(eventSubscriber) {
        console.log('FacadeRegistry::addEventUnsubscriber: %o', eventSubscriber);
        const globalThis = this.getGlobalThis();
        globalThis === null || globalThis === void 0 ? void 0 : globalThis.addEventListener('beforeunload', () => {
            console.log('FacadeRegistry::beforeunload');
        });
        globalThis === null || globalThis === void 0 ? void 0 : globalThis.addEventListener('visibilitychange', () => {
            console.log('FacadeRegistry::visibilitychange: %s', document.visibilityState);
        });
        globalThis === null || globalThis === void 0 ? void 0 : globalThis.addEventListener('pagehide', (event) => {
            console.log('FacadeRegistry::pagehide: %s', event.persisted ? 'persisted' : 'not persisted');
            if (!event.persisted) {
                eventSubscriber.unsubscribe();
            }
        });
        globalThis === null || globalThis === void 0 ? void 0 : globalThis.addEventListener('pageshow', (event) => {
            console.log('FacadeRegistry::pageshow: %s', event.persisted ? 'persisted' : 'not persisted');
        });
    }
    static eventingFallbackNotAllowedError() {
        console.warn('Eventing Fallback was not allowed.');
        const error = {
            errorType: EventServiceErrorType.eventingFallbackNotAllowed,
            reason: 'Eventing Fallback was not allowed.'
        };
        return error;
    }
    static getCreatePublisherFunction(eventingPlugin) {
        console.log('FacadeRegistry::getCreatePublisherFunction');
        return (_publisherId, createPublisherOptions) => __awaiter(this, void 0, void 0, function* () {
            if (!createPublisherOptions || !createPublisherOptions.allowEventingFallback) {
                return FacadeRegistry.eventingFallbackNotAllowedError();
            }
            const publisher = {
                publish: (eventName, eventData) => __awaiter(this, void 0, void 0, function* () {
                    eventingPlugin.dispatchEvent({
                        name: eventName,
                        data: eventData
                    });
                }),
                destroy: () => __awaiter(this, void 0, void 0, function* () { })
            };
            return publisher;
        });
    }
    static isMatchingEventHandle(eventingHandle, eventName, publisherId) {
        return (eventName &&
            publisherId &&
            eventingHandle.eventName === eventName &&
            eventingHandle.publisherId === publisherId) ||
            (eventName &&
                (publisherId === undefined || publisherId === null) &&
                eventingHandle.eventName === eventName) ||
            (publisherId &&
                (eventName === undefined || eventName === null) &&
                eventingHandle.publisherId === publisherId) ||
            (!eventName && !publisherId);
    }
    static getCreateSubscriberFunction(eventingPlugin) {
        console.log('FacadeRegistry::getCreateSubscriberFunction');
        return (createSubscriberOptions) => __awaiter(this, void 0, void 0, function* () {
            if (!createSubscriberOptions || !createSubscriberOptions.allowEventingFallback) {
                return FacadeRegistry.eventingFallbackNotAllowedError();
            }
            let eventingHandles = new Array();
            const subscriber = {
                subscribe: (options, eventHandler) => __awaiter(this, void 0, void 0, function* () {
                    const eventHandlerWrapper = (data, name) => {
                        const info = {
                            subscriber: null,
                            publisherId: options.publisherId,
                            eventName: name,
                            eventData: data
                        };
                        eventHandler(info);
                    };
                    const eventingHandle = eventingPlugin.addListener(options.eventName, eventHandlerWrapper);
                    let isHandleActive = true;
                    const subscriptionHandle = {
                        unsubscribe: () => __awaiter(this, void 0, void 0, function* () {
                            eventingHandle.remove();
                            isHandleActive = false;
                        }),
                        isActive: isHandleActive
                    };
                    eventingHandles.push({
                        eventName: options.eventName,
                        publisherId: options.publisherId,
                        handle: eventingHandle
                    });
                    return subscriptionHandle;
                }),
                unsubscribe: (eventName, publisherId) => __awaiter(this, void 0, void 0, function* () {
                    eventingHandles = eventingHandles.filter((eventingHandle) => {
                        if (FacadeRegistry.isMatchingEventHandle(eventingHandle, eventName, publisherId)) {
                            eventingHandle.handle.remove();
                            return false;
                        }
                        return true;
                    });
                })
            };
            return subscriber;
        });
    }
}
FacadeRegistry.getGlobalThis = () => {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    return null;
};
// Fixed order of facades.
// These facades are applied sequentially
FacadeRegistry.facades = [
    (jWeb) => {
        if (!jWeb.isPluginAvailable("Eventing") || jWeb.isPluginAvailable("EventService")) {
            // Cannot adapt EventService if Eventing is not available
            // Do not want to adapt EventService if it is available
            return;
        }
        const eventingPlugin = jWeb.Plugins.Eventing;
        // Create 'fake' Event Service
        const eventServiceFacade = {
            addListener: () => null,
            createSubscriber: FacadeRegistry.getCreateSubscriberFunction(eventingPlugin),
            createPublisher: FacadeRegistry.getCreatePublisherFunction(eventingPlugin)
        };
        jWeb.Plugins.EventService = eventServiceFacade;
    },
    (jWeb) => {
        if (!jWeb.isPluginAvailable("EventService")) {
            // Cannot unsubscribe automatically if EventService is not available
            return;
        }
        const eventServicePlugin = jWeb.Plugins.EventService;
        // Automatically unsubscribe event subscribers during page unloading
        if (eventServicePlugin.createSubscriber) {
            const createSubscriberOriginal = eventServicePlugin.createSubscriber;
            eventServicePlugin.createSubscriber = (options) => __awaiter(void 0, void 0, void 0, function* () {
                const subscriberResult = yield createSubscriberOriginal(options);
                if (FacadeRegistry.isSubscriber(subscriberResult)) {
                    FacadeRegistry.addEventUnsubscriber(subscriberResult);
                }
                return subscriberResult;
            });
        }
        jWeb.Plugins.EventService = eventServicePlugin;
    },
    (jWeb) => {
        if (!jWeb.isPluginAvailable("DataCollection") || !jWeb.isPluginAvailable("EventService")) {
            // Do not want to adapt DataCollection if it was not injected in the first place
            // Cannot adapt DataCollection if EventService is not available
            return;
        }
        const dataCollectionPlugin = jWeb.Plugins.DataCollection;
        if (!FacadeRegistry.isLegacyDataCollectionPlugin(dataCollectionPlugin)) {
            return;
        }
        // If the native side injects the legacy data collection method..
        dataCollectionPlugin.invalidateCache = dataCollectionPlugin.refreshCollectionProfile;
        if (dataCollectionPlugin.sendUiEvent) {
            FacadeRegistry.createEventSubscriber(jWeb).then((subscriber) => {
                // Handle EventService communicating with app that has old data collection component
                if (subscriber) {
                    // Register our listener
                    const subscribeOptions = {
                        eventName: DataCollectionEventNames.cdmEvent
                    };
                    subscriber.subscribe(subscribeOptions, (eventInfo) => {
                        // Check if this is a simpleUi event!
                        try {
                            const dataValveCDMEventData = eventInfo.eventData;
                            dataValveCDMEventData.events.forEach((cdmEventData) => {
                                if (cdmEventData.eventCategory === 'simpleUi') {
                                    const simpleUiEvent = (cdmEventData.eventDetail);
                                    console.log('FacadeRegistry::AdaptPluginFunction: Forwarding Simple UI event to legacy DataCollection plugin: %o', simpleUiEvent);
                                    dataCollectionPlugin.sendUiEvent(simpleUiEvent).then(() => {
                                        console.log('FacadeRegistry::AdaptPluginFunction: Successfully forwarded Simple UI event to legacy DataCollection plugin');
                                    }).catch(error => {
                                        console.error('FacadeRegistry::AdaptPluginFunction: Error forwarding Simple UI event to legacy DataCollection plugin: %o', error);
                                    });
                                }
                            });
                        }
                        catch (e) {
                            console.error(e);
                        }
                    });
                }
            });
        }
    }
];
//# sourceMappingURL=facade-registry.js.map